// Two-pill segmented toggle that swaps between the Pick (scan) view
// and the Put Away view inside Shelf Drop / Forecast Drop. Visually
// matches the Low/High tier toggle on the Pick Queue selector
// (`.picking-tier-toggle` + `.picking-tier-pill`) so the two pages
// feel like one product. The Put Away pill carries a small count
// badge driven by /drop/queue-count polling.
import { ArrowDownToLine, PackageOpen } from "lucide-react";
import { useTranslation } from "../../i18n";

export type DropView = "scan" | "put-away";

interface Props {
    view: DropView;
    putAwayCount: number;
    itemsCount: number;
    onChange: (next: DropView) => void;
}

const DropViewToggle = ({ view, putAwayCount, itemsCount, onChange }: Props) => {
    const { t } = useTranslation();
    return (
        <div className="picking-tier-toggle" role="radiogroup" aria-label={t("drop_view_toggle")}>
            <button
                type="button"
                role="radio"
                aria-checked={view === "scan"}
                className={`picking-tier-pill drop-view-pill--scan${view === "scan" ? " picking-tier-pill--active" : ""}`}
                onClick={() => onChange("scan")}
                title={t("drop_view_pick")}
                aria-label={t("drop_view_pick")}
            >
                <ArrowDownToLine size={16} strokeWidth={2.2} aria-hidden="true" />
                {itemsCount > 0 && (
                    <span className="drop-pick-badge">{itemsCount}</span>
                )}
            </button>
            <button
                type="button"
                role="radio"
                aria-checked={view === "put-away"}
                className={`picking-tier-pill drop-view-pill--put-away${view === "put-away" ? " picking-tier-pill--active" : ""}`}
                onClick={() => onChange("put-away")}
                title={t("drop_view_put_away")}
                aria-label={t("drop_view_put_away")}
            >
                <PackageOpen size={16} strokeWidth={2.2} aria-hidden="true" />
                {putAwayCount > 0 && (
                    <span className="drop-put-away-badge">{putAwayCount}</span>
                )}
            </button>
        </div>
    );
};

export default DropViewToggle;
